"use client";

import { Carousel } from "nuka-carousel";

import type { ContentImage } from "../../_types/content";
import StorefrontMedia from "./StorefrontMedia";

export default function ProductGallery({
  images,
  productName,
}: {
  images: readonly ContentImage[];
  productName: string;
}) {
  return (
    <Carousel
      title={`${productName} gallery`}
      showArrows="always"
      wrapMode="wrap"
      scrollDistance="slide"
      className="w-full overflow-hidden rounded-[2rem]"
    >
      {images.map((image) => (
        <div key={image.src} className="w-full shrink-0">
          <StorefrontMedia image={image} sizes="(min-width: 1024px) 50vw, 100vw" />
        </div>
      ))}
    </Carousel>
  );
}
